(function () {
    $(document).ready(function () {
        $(".student-stories__text").slick({
            slidesToShow: 1,
            arrows: false,
            adaptiveHeight: true,
            asNavFor: ".student-stories__controls",
        });

        $(".student-stories__controls").slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            focusOnSelect: true,
            variableWidth: true,
            draggable: true,
            arrows: false,
            asNavFor: ".student-stories__text",
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        if ($(".student-stories__controls").length) {
            // Find the parent div with the class band and add a new class to it
            $(".student-stories__controls")
                .closest(".band")
                .addClass("band--student-stories");
        }
    });
})(this);
